import { ApiRequest } from "../../api/ApiRequest";
import { ApiPaths } from "../../api/ApiPaths";
import { UserPassword } from "../../../domain/user/UserPassword";

export async function changePassword(password: UserPassword) {
    return await ApiRequest.patch(
        ApiPaths.changePassword,
        {},
        {
            password: password.value
        },
        () => {},
        () => {});
}
